import { Component, effect, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent, EnumValues } from '@card-software/library';
import _ from 'lodash';
import { EnumService } from '../../../services/enum.service';
import { Invoice, S3Object } from '../../../models/invoice/invoice';
import { LocaleHelperService } from '../../../services/locale-helper.service';
import { ItemMasterProxyService } from '../../../proxies/item/item-master.proxy.service';

interface InvoiceItemRow {
  itemCode: string;
  itemDescription: string;
  quantity: number;
  uom?: number;
}

@Component({
  selector: 'app-invoice-detail-modal',
  templateUrl: './invoice-detail-modal.component.html',
  styleUrl: './invoice-detail-modal.component.scss',
})
export class InvoiceDetailModalComponent extends BaseModalComponent<Invoice | null> implements OnInit {
  @Input() invoice: Invoice | null = null;
  statuses: EnumValues = {};
  uoms: EnumValues = {};
  purchaseOrderNumbers = '';
  rows: InvoiceItemRow[] = [];

  constructor(
    injector: Injector,
    private enumService: EnumService,
    private itemMasterProxyService: ItemMasterProxyService,
    public localeHelperService: LocaleHelperService,
  ) {
    super(injector);
    effect(() => {
      this.statuses = this.enumService.getEnum('CustomerOrderStatus', 'orderEnums')
        ? this.enumService.getEnum('CustomerOrderStatus', 'orderEnums').values
        : {};
      this.uoms = this.enumService.getEnum('UnitOfMeasure', 'itemEnums')
        ? this.enumService.getEnum('UnitOfMeasure', 'itemEnums').values
        : {};
    });
  }

  ngOnInit(): void {
    if (!this.invoice) return;

    const purchaseOrders = this.invoice.purchaseOrders ?? [];
    const purchaseOrderNumbers = this.invoice.purchaseOrderNumbers?.length
      ? this.invoice.purchaseOrderNumbers
      : purchaseOrders.map((po) => po.purchaseOrderNumber);
    this.purchaseOrderNumbers = purchaseOrderNumbers.filter(Boolean).join(', ');

    const purchaseOrderItems = purchaseOrders.flatMap((po) => po.items ?? []);
    this.rows = (this.invoice.items ?? []).map((item) => {
      const purchaseOrderItem = purchaseOrderItems.find((poItem) => poItem.id === item.itemInPurchaseOrderId);
      return {
        itemCode: purchaseOrderItem?.itemCode ?? '',
        itemDescription: '',
        quantity: item.quantity,
        uom: purchaseOrderItem?.uom,
      };
    });

    const itemCodes = _.uniq(this.rows.map((row) => row.itemCode).filter(Boolean));
    if (itemCodes.length === 0) return;

    this.itemMasterProxyService.getItemCodesBatch({ itemCodes }).subscribe({
      next: (response) => {
        const itemMasters = response.data ?? [];
        this.rows.forEach((row) => {
          row.itemDescription = this.localeHelperService.getLocalizedValue(
            itemMasters.find((x) => x.itemCode === row.itemCode)?.itemDescription,
          );
        });
      },
    });
  }

  onClose() {
    this.close({ action: 'close', data: null });
    this.invoice = null;
  }

  public returnStatusName(key: number) {
    return this.statuses[key];
  }

  onFileClick(s3Object: S3Object) {
    if (s3Object.presignedUrl) {
      window.open(s3Object.presignedUrl, '_blank');
    }
  }

  getFileName(s3Object: S3Object) {
    const fileName = s3Object.name.split('/').pop();
    return fileName ? fileName : '';
  }
}
